import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'split-date-slide',
  templateUrl: './split-date-slide.component.html',
  styleUrls: ['./split-date-slide.component.scss']
})
export class SplitDateSlideComponent {
  date = new Date();

  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() type: 'year' | 'month-year' = 'month-year';

  prev() {
    let month = this.date.getMonth();

    switch(this.type) {
      case 'month-year':
        if(month <= 0) {
          this.date.setFullYear(this.date.getFullYear() - 1);
          this.date.setMonth(11);
          console.log(this.date);
        } else {
          this.date.setMonth(month - 1);
        }
      break;
      case 'year':
        this.date.setFullYear(this.date.getFullYear() - 1);
      break;    
    }

    this.date = new Date(this.date);
    this.onChange.emit({
      startDate: new Date(this.date.getFullYear(), this.date.getMonth(), 1),
      endDate: new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0)
    });
  }

  next() {
    let month = this.date.getMonth();

    switch(this.type) {
      case 'month-year':
        if(month >= 11) {
          this.date.setFullYear(this.date.getFullYear() + 1);
          this.date.setMonth(0);
        } else {
          this.date.setMonth(month + 1);
        }
      break;
      case 'year':
        this.date.setFullYear(this.date.getFullYear() + 1);
      break;    
    }
  
    this.date = new Date(this.date);

    this.onChange.emit({
      startDate: new Date(this.date.getFullYear(), this.date.getMonth(), 1),
      endDate: new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0)
    });
  }

  getDayByMonth(mounth: number, year: number) {
    var data = new Date(year, mounth, 0);
    return data.getDate();
  }
}
